import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LabelValue} from 'src/app/constants/general-constants';
import {ActivityLogScope, ItemCounts} from 'src/app/constantsObjects';
import {PageOfActivityLog} from 'src/app/model/activity-log.model';
import {UrlPrefixes} from 'src/app/model/cms-btv-core/config-controller/config-url-prefix.model';
import {ActivityLogService} from 'src/app/services/cms-vod-core/activity-log-controller/activity-log.service';
import {Utility} from 'src/app/utility/utility';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss'],
})
export class ActivityLogComponent implements OnInit {
  @Input('assetId') assetID: number;
  assetType: string;
  pageOfActivityLog: PageOfActivityLog;
  page: number = 0;
  assetId: string;
  host: string;
  prefix: UrlPrefixes;
  vodType: string;
  itemCounts: LabelValue[] = ItemCounts;
  itemCount: LabelValue = new LabelValue();
  justUserChanges: boolean = false;
  scopes: LabelValue[] = ActivityLogScope;
  scope: LabelValue = new LabelValue();
  loading: boolean = false;

  constructor(private activityLogService: ActivityLogService, private route: ActivatedRoute, public utility: Utility) {}

  ngOnInit(): void {
    this.assetId = this.route.parent.snapshot.params['id'];
    this.assetType = 'Content';
    if (this.assetId == undefined || this.assetId == null) {
      this.assetId = this.route.parent.snapshot.params['catchupId'];
      this.assetType = 'Catchup';
    } else if (this.assetID != null && this.assetID != undefined) {
      this.assetId = this.assetID.toString();
    }
    this.getActivitiyLogs();
  }

  getActivitiyLogs(): void {
    this.loading = true;
    this.activityLogService
      .getActivityLogs(this.page, this.itemCount.value, this.assetId, null, this.assetType, this.scope.value, this.justUserChanges)
      .subscribe((response) => {
        this.pageOfActivityLog = response;
        for (const activity of this.pageOfActivityLog.content) {
          if (activity.changes) {
            activity.changes = JSON.parse(activity.changes);
            
            if (activity.changes != null &&  activity.changes.processData != undefined ) {
              activity.changes.processData = JSON.parse(activity.changes.processData);
            }
           
          }
        }
        this.loading = false;
      });
  }

  resetActivityLogSearch(): void {
    this.justUserChanges = false;
    this.scope = new LabelValue();
    this.getActivitiyLogs();
  }
}
